import { createGlobalStyle } from "styled-components"
import styled from "styled-components"

export const GlobalStyle = createGlobalStyle`
    body {
        color: ${props => (props.whiteColor ? "white" : "black")};
    }

    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    body {
        font-family: sans-serif;
        font-size: 1rem;
        line-height: 1.6;
        background-color: #fff;
        color: #333;
    }

    a {
        text-decoration: none;
        color: black;
    }

    ul {
        list-style: none;
    }

    img {
        width: 100%;
    }

    hr {
        border: 0;
        height: 1px;
        background: #ddd;
    }
`

export const Container = styled.div`
  max-width: ${props => props.maxWidth || "900px"};
  margin: auto;
  padding: 0 1rem;
  padding-top: ${props => props.paddingTop || "0rem"};
`
